import moment from 'moment';
import useTranslation from '../../../../Hooks/useTranslation';

export const useEventStatus = () => {
	const { t } = useTranslation();

	const getEventStatusDisplay = (
		dateFrom: string | undefined,
		dateTo: string | undefined,
	) => {
		if (!dateFrom || !dateTo) {
			return null;
		}

		const now = moment();
		const from = moment(dateFrom);
		const to = moment(dateTo);

		if (now.isBefore(from)) {
			const mins = from.diff(now, 'minutes');
			const key =
				mins <= 1
					? 'patientTreatment.meddiDENT.dentalCross.upcomingExamination.statusStartsNow'
					: 'patientTreatment.meddiDENT.dentalCross.upcomingExamination.statusStartsIn';

			return t(key, mins <= 1 ? {} : { minutes: String(mins) });
		}

		if (now.isBetween(from, to, undefined, '[]')) {
			return t(
				'patientTreatment.meddiDENT.dentalCross.upcomingExamination.statusInProgress',
			);
		}

		const mins = now.diff(to, 'minutes');
		return t(
			'patientTreatment.meddiDENT.dentalCross.upcomingExamination.statusEndedAgo',
			{
				minutes: String(mins),
			},
		);
	};

	return { getEventStatusDisplay };
};
